export default __webpack_public_path__ + "static/logo_white-8aaad605fd6663c04f86536f6a2fbbc4.png";